import _ from 'lodash';
import moment from 'moment';
import swal from 'sweetalert';
import createSubcontractModal from "../../../common/modals/createSubcontractModal/createSubcontractModal.component";
import addSubcontractorEmployeeModal from "../../../common/modals/addSubcontractorEmployee/addSubcontractorEmployee.component";


class SubcontractorDetailsController {
  constructor($rootScope, $http, toastr, $state, AuthenticationService, $stateParams, $uibModal) {
    "ngInject";
    this.name = 'subcontractor';
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.auth = AuthenticationService;
    this.toastr = toastr;
    this.$state = $state;
    this.subcontractor;
    this.$uibModal = $uibModal;
    this.loadingSubcontractor = true;

    this.orderBy = {
      field: 'name',
      reverse: false
    };

    let self = this;

    this.$http.get($rootScope.apiHost+"/api/admin/subcontractors/"+$stateParams.subcontractorId, {withCredentials: true}).then(function (success) {
      self.subcontractor = success.data;
      self.loadingSubcontractor = false;
    });


    this.opened = {};
    this.open = function($event, elementOpened) {
      $event.preventDefault();
      $event.stopPropagation();
      self.opened[elementOpened] = !self.opened[elementOpened];
    };

    this.datePickerOptions = {
        formatYear: 'yy',
        startingDay: 1
    };

    this.datePickerFormat = 'MMM dd, yyyy';
  }


  checkXEditPermission(permission) {
    let result = false;

    if(this.auth.hasPermission(permission)){
      result = true;
    }

    return result;
  }

  checkPermission(e, permission) {
    if(!this.auth.hasPermission(permission)){
      e.preventDefault();
    }
  }


  changeSortOrder(sortField, defaultSort) {
    this.orderBy = {
      field: sortField,
      reverse: this.orderBy.field === sortField ? !this.orderBy.reverse : defaultSort
    }
  }

  loadContractRevenueData() {
    let self = this;

    if(this.auth.hasPermission('PERM_VIEW_CUSTOMER_REVENUE_INFORMATION')){
      this.$http.get(this.$rootScope.apiHost+"/api/admin/customers/"+this.selectedCustomer.id+"/revenue", {withCredentials: true}).then(function (success) {
        self.contractRevenueChartData = [];
        self.customer = success.data;
      });
    }

  }

  createSubcontract() {
    let self = this;
    var modalInstance = this.$uibModal.open(createSubcontractModal);

    modalInstance.success = function (subcontract) {
      self.$http.post(self.$rootScope.apiHost+'/api/admin/subcontractors/'+self.subcontractor.id+'/subcontracts', subcontract, { withCredentials: true}).then(function (success) {
        modalInstance.dismiss();
        self.$state.go("admin.subcontract-details", {'subcontractId': success.data.id});
        self.toastr.success("Successfully Created Subcontract", "SUCCESS");
      });
    };

    modalInstance.cancel = function () {
      modalInstance.dismiss();
    };
  }

  addSubcontractorEmployee() {
    let self = this;
    var modalInstance = this.$uibModal.open(addSubcontractorEmployeeModal);

    modalInstance.success = function (subcontractEmployee) {
      self.$http.post(self.$rootScope.apiHost+'/api/admin/subcontractors/'+self.subcontractor.id+'/employees', subcontractEmployee, { withCredentials: true}).then(function (success) {
        modalInstance.dismiss();

        self.toastr.success("Successfully Created Subcontract Employee", "SUCCESS");
      });
    };

    modalInstance.cancel = function () {
      modalInstance.dismiss();
    };
  }


  updateSubcontractorDetails(parameter, value) {
    let self = this;
    let obj = {};
    obj[parameter] = value;
    this.$http.patch(this.$rootScope.apiHost+"/api/admin/subcontractors/"+this.subcontractor.id, obj, {withCredentials: true}).then(function (success) {
      self.subcontractor = success.data;
      self.toastr.success("Successfully updated subcontractor details!", "SUCCESS");
    }, function (failure) {
      self.toastr.error("Could not update subcontractor details.", "ERROR");
    });
  }

  formatDate(date, format) {
    return moment(date).format(format);
  }


}


export default SubcontractorDetailsController;



// WEBPACK FOOTER //
// ./client/pages/admin/subcontractor-details/subcontractor-details.controller.js